import config from './translations.config.json'
import en from './languages/en.json'
import { TranslationsInterface } from '../types/translationsNew'

export type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends object ? (T[K] extends unknown[] ? T[K] : DeepPartial<T[K]>) : T[K]
}

export type LocaleId = keyof typeof config.locales

// en.json is the only complete file; every other locale only holds the values that differ from
// its fallback chain in translations.config.json.
export const source: TranslationsInterface = en

const files = import.meta.glob<DeepPartial<TranslationsInterface>>('./languages/*.json', {
  eager: true,
  import: 'default',
})

export const locales = Object.fromEntries(
  Object.keys(config.locales).map((id) => [id, files[`./languages/${id}.json`] ?? {}])
) as Record<LocaleId, DeepPartial<TranslationsInterface>>

export { config }
